export default __webpack_public_path__ + "static/media/ic_notifications_48px.8a6f9240.svg";